import _ from 'lodash';

const Answer = (data) => ({
  description: data.description,
  name: data.name,
  orderId: data.order_id,
  type: data.type,
  data: data.data,
});

export const Feedback = ({ data, included = [] }) => {
  const campaign = included.find((item) => item.type === 'campaigns' && item.id === _.get(data, 'relationships.campaign.data.id'));

  return {
    id: data.id,
    sourceId: data.attributes.source_id,
    image: data.attributes.image,
    name: data.attributes.spot.title,
    location: data.attributes.spot.location,
    date: data.attributes.spot.finished_at,
    spotAttributes: _.get(data, 'attributes.spot.attributes', []),
    user: data.attributes.user,
    spot: data.attributes.spot,
    answers: _.get(data, 'attributes.answers', []).map(Answer),
    campaign,
  };
};

export const FeedbacksList = (data, included) => (
  data.map((feedback) => Feedback({ data: feedback, included }))
);

const GroupedFeedback = (feedback) => ({
  id: _.get(feedback, '_id.$oid'),
  image: feedback.image,
  name: feedback.spot.title,
  location: feedback.spot.location,
  date: feedback.spot.finished_at,
});

const FeedbackGroup = (groupName, values) => ({
  key: groupName,
  groupName,
  children: values.map((f) => GroupedFeedback(f)),
});

export const GroupedFeedbacksList = (data) => (
  data.map((el) => FeedbackGroup(_.get(el, '_id.group_name'), el.values))
);
